<template>
  <a
    rel="noopener noreferrer"
    target="_blank"
    class="learn-more-item"
    :href="item?.url"
  >
    <div class="learn-more-item__link">
      <img v-if="isPublicPage" src="@/assets.v2/images/link-icon.svg" alt="" />
      <span v-else class="iconfont ilink"></span>
    </div>

    <div>
      <div class="learn-more-item__title">{{ item.name }}</div>
      <div class="learn-more-item__snippet">{{ item.snippet }}</div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { LearnMoreItem } from '@/models/interfaces'

withDefaults(
  defineProps<{
    item: LearnMoreItem
    isPublicPage?: boolean
  }>(),
  {
    isPublicPage: false,
  },
)
</script>

<style lang="scss" scoped>
.learn-more-item {
  display: flex;
  text-decoration: none;

  background: $c-white;
  border: 1px solid $c-border-7;
  border-radius: 8px;
  margin-top: 12px;
  padding: 8px;
  gap: 6px;
  transition: 0.3s;

  @include hover {
    text-decoration: none;
    color: inherit;
    border-color: $c-black-3;
  }

  &__title {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: $c-black-2;
    padding-right: 8px;
  }
  &__snippet {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.02em;
    color: $c-black-3;
  }
  &__link {
    margin-right: 8px;

    img {
      max-width: none;
      width: 24px;
    }
    .iconfont {
      font-size: 24px;
    }
  }
}

.night-mode .learn-more-item {
  background: $c-black-9;
  border-color: $c-black-10;

  @include hover {
    border-color: $c-white;
  }

  &__title {
    color: $c-white;
  }

  &__snippet {
    color: $c-dark-6;
  }

  &__link {
    color: $c-white;
  }
}
</style>
